import { render, staticRenderFns } from "./UserCardRadio.vue?vue&type=template&id=179b6e3a&scoped=true&"
import script from "./UserCardRadio.vue?vue&type=script&lang=js&"
export * from "./UserCardRadio.vue?vue&type=script&lang=js&"
import style0 from "./UserCardRadio.vue?vue&type=style&index=0&id=179b6e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b6e3a",
  null
  
)

export default component.exports